import { HttpErrorResponse } from '@angular/common/http';
import { AppError } from '@rms/sdk/errors';

export class PartnerDashboardAccessDeniedError extends AppError {
  constructor() {
    super(new HttpErrorResponse({ status: 0 }), 'auth.errors.no-access');
  }
}
